import React from 'react';
import Input from '../../../components/input';
import ErrorMessage from '../../../components/error_message';
import Textarea from '../../../components/textarea';
import ColorPicker from '../../../components/color_picker';
import { colorPickerColors } from 'constants/colors';
import Checkbox from '../../../components/checkbox';
import { spell } from 'helpers/international_spelling';
import useGym from 'helpers/use_gym';

interface EditSequenceContactFlagPayloadProps {
  payload: any;
  stepIndex: number;
  updatePayload: (payload: any, stepIndex: number) => void;
  displayValidationErrors: boolean;
}

const EditSequenceContactFlagPayload = ({
  payload,
  stepIndex,
  updatePayload,
  displayValidationErrors,
}: EditSequenceContactFlagPayloadProps) => {
  const onUpdate = (updated) => {
    updatePayload({ ...payload, ...updated }, stepIndex);
  };

  const gym = useGym();

  return (
    <div className="template-details">
      <div className="row form-group">
        <div className="col-sm-4 col-lg-4">
          <label className="control-label">Flag title</label>
        </div>
        <div className="col-sm-8 col-lg-8">
          <Input value={payload.flag_title} onChange={(flag_title) => onUpdate({ flag_title })} />
        </div>
      </div>
      <div className="row form-group">
        <div className="col-sm-4 col-lg-4">
          <label className="control-label">Flag description</label>
        </div>
        <div className="col-sm-8 col-lg-8">
          <Textarea
            value={payload.flag_description}
            onChange={(flag_description) => onUpdate({ flag_description })}
          />

          {displayValidationErrors && !payload.flag_description?.trim() && (
            <ErrorMessage error="Is invalid" />
          )}
        </div>
      </div>
      <div className="row form-group">
        <div className="col-sm-4 col-lg-4">
          <label className="control-label">{spell('Color', gym?.country)}</label>
        </div>
        <div className="col-sm-8 col-lg-8">
          <ColorPicker
            colors={colorPickerColors}
            value={payload.color}
            onChange={(color) => onUpdate({ color })}
            variant="v2"
          />
        </div>
      </div>
      <div className="form-group">
        <Checkbox
          checked={payload.public_flag}
          onChange={(public_flag) => onUpdate({ public_flag })}
        >
          Show in Kiosk mode?
        </Checkbox>

        <div className="margin-top-8">
          <Checkbox
            checked={payload.skip_if_matching_flag_exists}
            onChange={(skip_if_matching_flag_exists) => onUpdate({ skip_if_matching_flag_exists })}
          >
            Skip this step, if contact already has a flag with the same description?
          </Checkbox>
        </div>
      </div>
    </div>
  );
};

angular.module('gym').value('EditSequenceContactFlagPayload', EditSequenceContactFlagPayload);
